import Vue from "vue";
import router from "./router";
import App from "./App.vue";
import store from "./store";
// LLAMADOS REST
import axios from "axios";
// ESTILOS Y DISEÑO
import vuetify from "./vuetify";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "font-awesome/css/font-awesome.css";
// CUSTOM ESTILO SIGAS
import "./style/sigas.styl";
// ALERTAS FLASH
import FlashMessage from "@smartweb/vue-flash-message";
//import V_Echarts from 'vue-echarts-directive';
// require('./plugins')
import EChart from "echarts";
//axios.defaults.baseURL = process.env.API_ENDPOINT;

Vue.use(FlashMessage);
Vue.use(EChart);

Vue.prototype.$http = axios;

//PRODUCCION
axios.defaults.baseURL = "https://sigas.agenciaeducacion.cl/api";
// axios.defaults.baseURL = "http://localhost:8080/api";
// axios.defaults.baseURL = "https://testsigas.agenciaeducacion.cl/api";

axios.interceptors.request.use((config) => {
  config.headers["X-Frame-Options"] = "DENY";
  // console.log("config:" + JSON.stringify(config, null, 2));
  return config;
});

Vue.prototype.$http.defaults.headers.common["X-Frame-Options"] = "DENY";
axios.defaults.headers.common["X-Frame-Options"] = "DENY";

const token = localStorage.getItem("token");
if (token) {
  Vue.prototype.$http.defaults.headers.common["Authorization"] =
    "Bearer " + token;
}
Vue.config.productionTip = false;

// Add a 401 response interceptor
axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    console.log("Encabezados de error:", error.response.status);
    if (401 === error.response.status) {
      window.getApp.$emit("APP_UNAUTHORIZED");
    } else if (403 === error.response.status) {
      window.getApp.$emit("APP_UNAUTHORIZED");
    } else {
      return Promise.reject(error);
    }
  }
);

new Vue({
  router,
  store,
  vuetify,
  EChart,
  render: (h) => h(App),
}).$mount("#app");
